import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axiosInstance from "../request";
import { URL } from "../api";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import getPrivilegeList from "./PrivilegeList";


const LoanView = () => {
  const location = useLocation();

  const getLoanId = () => {
    const search = location.search || location.hash.split("?")[1] || "";
    const params = new URLSearchParams(search);
    return params.get("loanId");
  };

  const formatCurrency = (value) => {
    if (value == null) return "0";
    return value.toLocaleString();
  };


  const [editSection, setEditSection] = useState(null);
  const [editableData, setEditableData] = useState({
    loan_status: "",
    disbursal_status: "",
    comment: "",
  });

  const isEditing = (section) => editSection === section;

const [showRuleInputs, setShowRuleInputs] = useState(false);
const [ruleCustomerId, setRuleCustomerId] = useState("");
const [ruleLoanId, setRuleLoanId] = useState("");
const [showMandatePopup, setShowMandatePopup] = useState(false);


// 🔹 Collection pagination states

const [colLoading, setColLoading] = useState(false);
const [colCurrentPage, setColCurrentPage] = useState(1);
const [colRowsPerPage] = useState(10);
const [colHasNextPage, setColHasNextPage] = useState(false);



  const loanId = getLoanId();
  const [loan, setLoan] = useState(null);
  const [emiList, setEmiList] = useState([]);
  const [outstanding, setOutstanding] = useState(null);
  const [collectionList, setCollectionList] = useState([]);
  const totalReceivedAmount = collectionList.reduce(
  (sum, item) => sum + (Number(item.tran_amount) || 0),
  0
);

const [customerVpa, setCustomerVpa] = useState("");
const [mandateAmount, setMandateAmount] = useState("");
const [showFeesWaveOffPopup, setShowFeesWaveOffPopup] = useState(false);
const [waveOffAmount, setWaveOffAmount] = useState("");
const outstandingFeesAmount =
  outstanding?.totalOutstandingFees != null
    ? outstanding.totalOutstandingFees
    : 0;

  const privilegeList = getPrivilegeList();

  useEffect(() => {
    if (loanId) {
      fetchLoanDetails(loanId);
    }
  }, [loanId]);

  const fetchOutstanding = async (loanId) => {
  try {
    const res = await axiosInstance.get(`${URL.LOAN_OUTSTANDING}?loanId=${loanId}`);

    if (res.data) {
      setOutstanding(res.data);
    } else {
      setOutstanding(null);
    }
  } catch (error) {
    console.error("Failed to fetch outstanding:", error);
    setOutstanding(null);
  }
};

const fetchCollections = async (loanId, page = 1) => {
  setColLoading(true);
  try {
    const params = new URLSearchParams();
    params.append("loanId", loanId);
    params.append("page", page - 1); // backend 0-based
    params.append("size", colRowsPerPage);

    const res = await axiosInstance.get(
      `${URL.COLLECTION_LIST}?${params.toString()}`
    );

    const data = Array.isArray(res.data) ? res.data : [];

    setCollectionList(data);
    setColCurrentPage(page);

    // same logic as CollectionList page
    setColHasNextPage(data.length === colRowsPerPage);
  } catch (error) {
    console.error("Failed to fetch collections:", error);
    setCollectionList([]);
    setColHasNextPage(false);
  } finally {
    setColLoading(false);
  }
};


const handleFeesWaveOffSubmit = async () => {
  if (!waveOffAmount || Number(waveOffAmount) <= 0) {
    toast.error("Please enter valid wave-off amount");
    return;
  }

  try {
    await axiosInstance.post(
      `${URL.FEES_WAVE_OFF}?loanId=${loan.partnerLoanId}&amount=${waveOffAmount}`
    );

    toast.success("Fees wave-off applied successfully");

    setShowFeesWaveOffPopup(false);
    setWaveOffAmount("");

    // refresh outstanding after wave-off
    fetchOutstanding(loan.partnerLoanId);

  } catch (error) {
    toast.error(
      error.response?.data?.message || "Failed to apply fees wave-off"
    );
  }
};



  const handleSave = async () => {
    if (!editableData.comment?.trim()) {
      toast.error("Please write a comment before updating.", {
        position: "top-right",
      });
      return;
    }

    try {
      const userId = localStorage.getItem("userId");

      // Build payload dynamically
      const payload = {
        customer_id: loan.customerId,
        loan_id: loan.partnerLoanId,
        comment: editableData.comment,
        comment_by: Number(userId),
      };

      // ✅ Add only if user changed these
      if (editableData.loan_status) {
        payload.loan_status = Number(editableData.loan_status);
      }
      if (editableData.disbursal_status) {
        payload.disbursal_status = Number(editableData.disbursal_status);
      }

      const res = await axiosInstance.post(URL.ALL_STATUS_CHANGE, payload);

      // toast.success(res.data.message || "Status updated successfully", {
      //   position: "top-right",
      // });

      if (res.data.error) {
        toast.error(res.data.error, { position: "top-right" });
      }

      if (res.data.message) {
        toast.success(res.data.message, { position: "top-right" });
      }

      if (!res.data.error && !res.data.message) {
        toast.success("Status updated successfully", { position: "top-right" });
      }


      setEditSection(null);

      fetchLoanDetails(loan.partnerLoanId); // refresh
    } catch (error) {
      console.error("Failed to update loan status", error);
      toast.error(
        error.response?.data?.message || "Failed to update loan status",
        { position: "top-right" }
      );
    }
  };



  const handleSendNoc = async () => {
  try {
    const token = localStorage.getItem("token");

    const res = await axiosInstance.post(
      `${URL.SEND_NOC}?loanId=${loan.partnerLoanId}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

   


    const msg = res.data || "NOC sent successfully";

    if (msg.includes("success") || msg.includes("Successfully") || msg.includes("sent")) {
      toast.success(msg, { position: "top-right" });
    } else {
      toast.error(msg, { position: "top-right" });
    }

  } catch (err) {
    const errorMsg = err.response?.data || "Failed to send NOC";
    toast.error(errorMsg, { position: "top-right" });
  }
};


  const fetchLoanDetails = async (loanId) => {
    try {
      const res = await axiosInstance.get(`${URL.LOAN_LIST}?loanId=${loanId}`);
      if (Array.isArray(res.data) && res.data.length > 0) {
        const loanData = res.data[0];
        setLoan({
          partnerLoanId: loanData.loan_id,
          loanAmount: loanData.loan_amount,
          rateOfInterest: loanData.roi,
          tenure: loanData.tenure,
          status: loanData.status_name,
          loanDate: loanData.disbursed_date?.slice(0, 10),
          customerId: loanData.customer_id,
          emiAmount: loanData.emi_amount,
          repaymentType: loanData.repayment_type_name
        });

        fetchEmiSchedule(loanData.customer_id, loanData.loan_id);

              // ✅ **IMPORTANT: OUTSTANDING API CALL**
      fetchOutstanding(loanData.loan_id);
      fetchCollections(loanData.loan_id, 1);

      }
    } catch (error) {
      console.error("Failed to fetch loan details:", error);
    }
  };

  const formatAmountTwoDecimal = (amount) => {
  if (amount == null) return "0.00";
  return Number(amount).toFixed(2);
};

const getRecurrencePattern = () => {
  if (!loan?.repaymentType) return "ASPRESENTED";

  const type = loan.repaymentType.toUpperCase();

  if (type === "DAILY") return "DAILY";
  return "ASPRESENTED";
};

const handleMandateRegistration = async () => {
  if (!customerVpa.trim()) {
    toast.error("Please enter Customer VPA");
    return;
  }

  if (!mandateAmount || Number(mandateAmount) <= 0) {
  toast.error("Please enter valid mandate amount");
  return;
}

  try {
    const payload = new URLSearchParams();
    payload.append("customerId", loan.customerId);
    payload.append("amount", formatAmountTwoDecimal(mandateAmount));
    payload.append("customerVpa", customerVpa);
    payload.append("recurrencePattern", getRecurrencePattern());

    const res = await axiosInstance.post(
      URL.JUSAPY_MANDATE_REGISTRATION,
      payload,
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }
    );

    toast.success("Mandate registered successfully");
    setShowMandatePopup(false);
    setCustomerVpa("");

  } catch (error) {
    toast.error(
      error.response?.data?.message || "Mandate registration failed"
    );
  }
};


  const handleRuleEngineView = () => {
  const cid = loan?.customerId;
  const lid = loan?.partnerLoanId;

  // If no loan ID, show toast
  if (!lid || lid === "" || lid === null) {
    toast.error("Loan is not created yet");
    return;
  }

  // Auto navigate
  window.location.href = `#/RuleEngine?customerId=${cid}&loanId=${lid}`;
};



  const fetchEmiSchedule = async (customerId, loanId) => {
    try {
      const res = await axiosInstance.get(
        `${URL.GET_ALL_EMI}?customerId=${customerId}&loanId=${loanId}`
      );
      if (Array.isArray(res.data)) {
        const emis = res.data.map((emi) => ({
          installmentNo: emi.emi_number,
          dueDate: (emi.emi_date.startsWith("0025") ? "2025" + emi.emi_date.slice(4) : emi.emi_date),
          paidDate: emi.emi_status === "Paid" ? emi.update_date : "-",
          emiAmount: emi.emi_amount,
          principalComponent: emi.principal,
          interestComponent: emi.interest,
          status: emi.emi_status,
          fullIntrest: emi.full_tenure_intrest,
          fullEmiAmount: emi.full_emi_amount,
          pfgst: emi.pfgst
        }));
        setEmiList(emis);
      }
    } catch (error) {
      console.error("Failed to fetch EMI schedule:", error);
      setEmiList([]);
    }
  };

  if (!loan) return <div className="text-center mt-5">Loading loan details...</div>;

  return (
    <div className="container mt-4">
      <h3 className="mb-4">Loan Details</h3>

{privilegeList.disbursementDetailsView && loan.status !== "Pending" && (
  <div className="d-flex justify-content-end mb-2">
    <button
      className="btn btn-sm btn-primary"
      onClick={() =>
        (window.location.href = `#/DisbursementView?loanId=${loan.partnerLoanId}&customerId=${loan.customerId}`)
      }
    >
    Loan Card
    </button>
  </div>
)}

      {/* Loan Info Card */}
      <div className="card mb-4 shadow-sm">
        <div className="card-header bg-dark text-white">Loan Summary</div>
        <div className="card-body row g-3">
          <div className="col-md-6">
            <label><strong>Loan ID</strong></label>
            <input className="form-control" disabled value={`#${loan.partnerLoanId}`} />
          </div>
          <div className="col-md-6">
            <label><strong>Loan Amount</strong></label>
            <input className="form-control" disabled value={`₹${loan.loanAmount.toLocaleString()}`} />
          </div>
          <div className="col-md-6">
            <label><strong>Interest Rate</strong></label>
            <input className="form-control" disabled value={`${loan.rateOfInterest}%`} />
          </div>
          <div className="col-md-6">
            <label><strong>Tenure</strong></label>
            <input className="form-control" disabled value={`${loan.tenure} days`} />
          </div>
          <div className="col-md-6">
            <label><strong>Status</strong></label>
            <input
              className={`form-control fw-bold text-white ${loan.status === "Active" ? "bg-success" : "bg-secondary"}`}
              disabled
              value={loan.status}
            />
          </div>
          <div className="col-md-6">
            <label><strong>Loan Date</strong></label>
            <input className="form-control" disabled value={loan.loanDate} />
          </div>
        </div>
      </div>

      {/* Status Management */}
      {privilegeList.statusEdit && (
        <div className="card mt-3 shadow-sm">
          <div className="card-header bg-dark text-white d-flex justify-content-between align-items-center">
            <span>Status Management</span>
            {!isEditing("Status") ? (
              privilegeList.statusEdit && (
                <button
                  className="btn btn-sm btn-warning"
                  onClick={() => {
                    setEditableData({
                      loan_status: "",
                      disbursal_status: "",
                      comment: "",
                    });
                    setEditSection("Status");
                  }}
                >
                  Edit
                </button>
              )
            ) : (
              <div>
                <button className="btn btn-sm btn-success me-2" onClick={handleSave}>
                  Save
                </button>
                <button
                  className="btn btn-sm btn-secondary"
                  onClick={() => setEditSection(null)}
                >
                  Cancel
                </button>
              </div>
            )}
          </div>

          <div className="card-body row">
            <div className="col-md-6 mb-2">
              <label>Loan Status</label>
              <select
                className="form-control"
                value={
                  isEditing("Status")
                    ? editableData.loan_status || ""
                    : loan.status || "-NA-"
                }
                onChange={(e) =>
                  setEditableData((prev) => ({
                    ...prev,
                    loan_status: e.target.value,
                  }))
                }
                disabled={!isEditing("Status")}
              >
                <option value="">Select</option>
                <option value="1">Active</option>
                <option value="2">Pending</option>
                <option value="3">Closed</option>
                <option value="4">Reject</option>
                <option value="5">Approved</option>
              </select>
            </div>


            <div className="col-md-12 mb-2">
              <label>Comment</label>
              <textarea
                className="form-control"
                value={isEditing("Status") ? editableData.comment || "" : "-"}
                onChange={(e) =>
                  setEditableData((prev) => ({
                    ...prev,
                    comment: e.target.value,
                  }))
                }
                disabled={!isEditing("Status")}
              />
            </div>
          </div>
        </div>
      )}


{/* Rule Engine Box */}
{privilegeList.breView && (
<div className="card shadow-sm mt-4">
  <div className="card-body text-center">
    <h6 className="text-uppercase text-muted mb-2">Rule Engine</h6>

    <button
      className="btn btn-outline-primary btn-sm"
      onClick={handleRuleEngineView}
    >
      View
    </button>
  </div>
</div>
)}

{/* Mandate Registration */}
<div className="card shadow-sm mt-3">
  <div className="card-body text-center">
    <h6 className="text-uppercase text-muted mb-2">Mandate Registration</h6>

    <button
  className="btn btn-warning btn-sm"
  onClick={() => {
    setMandateAmount(formatAmountTwoDecimal(loan.emiAmount));
    setShowMandatePopup(true);
  }}
>
  Register Mandate
</button>
  </div>
</div>


{/* Send NOC Button */}
<div className="card shadow-sm mt-3">
  <div className="card-body text-center">
    <h6 className="text-uppercase text-muted mb-2">Loan NOC</h6>

    <button
      className="btn btn-success btn-sm"
      onClick={handleSendNoc}
    >
      Send NOC
    </button>
  </div>
</div>

{/* OUTSTANDING SUMMARY */}
{outstanding && (
<div className="card shadow-sm">
       <div className="card-header bg-primary text-white d-flex justify-content-between align-items-center">
  <span>Outstanding Summary</span>

  {privilegeList.feesWaveOff && (
    <button
      className="btn btn-sm btn-light"
     onClick={() => {
  if (!outstanding) {
    toast.error("Outstanding data not loaded yet");
    return;
  }
  setShowFeesWaveOffPopup(true);
}}

    >
      Fees Wave Off
    </button>
  )}
</div>


    {/* 🔥 JUST ADD THIS STYLE BELOW → MINIMUM CHANGE */}
    <div className="table-responsive" style={{ whiteSpace: "nowrap" }}>
      <table className="table table-bordered table-hover align-middle mb-0">
        <thead className="table-light">
          <tr className="text-center">
            <th>Loan ID</th>
            <th>Pending EMI Count</th>
            <th>Outstanding EMI Amount</th>
            <th>Outstanding Interest</th>
            <th>Outstanding Principal</th>
            <th>Outstanding Penal Charge</th>
            <th>Overdue Amount</th>
            <th>Total WaveOff Charge</th>
            <th>Total Amount Received</th>
          </tr>
        </thead>

        <tbody>
          <tr className="text-center">
            <td>{outstanding.loanId}</td>
            <td>{outstanding.pendingEmiCount}</td>

            <td>₹{formatCurrency(outstanding.totalOutstandingEmiAmount)}</td>
            <td>₹{formatCurrency(outstanding.totalOutstandingInterest)}</td>
            <td>₹{formatCurrency(outstanding.totalOutstandingPrincipal)}</td>
            <td>₹{formatCurrency(outstanding.totalOutstandingFees)}</td>
            <td className="fw-bold text-danger">
              ₹{formatCurrency(outstanding.totalOverdueAmount)}
            </td>
             <td className="fw-bold text-danger">
              ₹{formatCurrency(outstanding.totalFeesWaveOff)}
            </td>
            <td className="fw-bold text-success">
            ₹{formatCurrency(outstanding.totalCollectedAmount)}
          </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
)}

{/* COLLECTION LIST */}
{collectionList.length > 0 && (
  <div className="card shadow-sm mt-4">
    <div className="card-header bg-dark text-white">
      Collection Details
    </div>

    <div className="table-responsive" style={{ whiteSpace: "nowrap" }}>
      <table className="table table-bordered table-hover align-middle mb-0">
        <thead className="table-light">
          <tr className="text-center">
            <th>S.No.</th>
            <th>Cust Name</th>
            <th>C.ID</th>
            <th>L.ID</th>
            <th>Pay.ID</th>
            <th>Tran ID</th>
            <th>Collection Date</th>
            <th>Amount (₹)</th>
            <th>Mode</th>
            <th>Extra</th>
            <th>Refund</th>
          </tr>
        </thead>

        <tbody>
  {collectionList.map((col, index) => (
    <tr key={index} className="text-center">
    <td>{(colCurrentPage - 1) * colRowsPerPage + index + 1}</td>


      <td>{col.full_name || "-"}</td>
      <td>{col.customer_id}</td>
      <td>{col.loan_id}</td>

      <td>{col.payment_id || "-"}</td>
      <td>{col.tran_id || col.utr || "-"}</td>

      <td>{col.tran_date || col.create_date || "-"}</td>

      <td>₹{formatCurrency(col.tran_amount)}</td>

      <td>{col.service || col.tran_type_value || "-"}</td>

      <td>
        {col.extra_amount !== null
          ? `₹${formatCurrency(col.extra_amount)}`
          : "-"}
      </td>

      <td>
        {col.refunded_amount !== null
          ? `₹${formatCurrency(col.refunded_amount)}`
          : "-"}
      </td>
    </tr>
  ))}
</tbody>

      </table>
    </div>
  </div>
)}
{colLoading ? (
  <div className="d-flex align-items-center p-2" style={{ gap: 8 }}>
    <span className="spinner-border spinner-border-sm"></span>
    <span>Loading collections...</span>
  </div>
) : (
  <div className="d-flex justify-content-center my-3">
    <div className="d-flex align-items-center" style={{ gap: "10px" }}>
      <button
        className="btn btn-sm btn-outline-primary"
        onClick={() => fetchCollections(loan.partnerLoanId, colCurrentPage - 1)}
        disabled={colCurrentPage === 1}
      >
        Prev
      </button>

      <span className="fw-semibold">Page {colCurrentPage}</span>

      {colHasNextPage && <span className="text-muted">...</span>}

      <button
        className="btn btn-sm btn-outline-primary"
        onClick={() => fetchCollections(loan.partnerLoanId, colCurrentPage + 1)}
        disabled={!colHasNextPage}
      >
        Next
      </button>
    </div>
  </div>
)}


      {/* EMI Schedule */}
      <div className="card shadow-sm">
        <div className="card-header bg-primary text-white d-flex justify-content-between align-items-center">
          <span>EMI Schedule</span>
          <span className="badge bg-info text-dark">Total EMIs: {emiList.length}</span>
        </div>
        <div className="table-responsive" style={{ whiteSpace: "nowrap" }}>
          <table className="table table-bordered table-hover align-middle mb-0">
            <thead className="table-light" style={{ whiteSpace: "nowrap" }}>
              <tr className="text-center">
                <th>Installment</th>
                <th>Due Date</th>
                <th>Paid Date</th>
                <th>EMI Amount</th>
                <th>Principal</th>
                <th>Interest</th>
                <th>Status</th>
                {privilegeList.pfgstView && <th>PF+GST</th>}
                <th>Full Emi Amount</th>
                <th>Full Tenure Intrest</th>
              </tr>
            </thead>
            <tbody>
              {emiList.length > 0 ? (
                emiList.map((emi, index) => (
                  <tr key={index} className="text-center">
                    <td>{emi.installmentNo}</td>
                    <td>{emi.dueDate}</td>
                    <td>{emi.status === "Paid" ? emi.paidDate : "-"}</td>
                    {/* <td>₹{emi.emiAmount.toLocaleString()}</td>
                    <td>₹{emi.principalComponent.toLocaleString()}</td>
                    <td>₹{emi.interestComponent.toLocaleString()}</td> */}
                    <td>₹{formatCurrency(emi.emiAmount)}</td>
                    <td>₹{formatCurrency(emi.principalComponent)}</td>
                    <td>₹{formatCurrency(emi.interestComponent)}</td>
                    <td>
                      <span
                        className={`badge rounded-pill px-3 py-2 ${emi.status === "Paid"
                            ? "bg-success"
                            : emi.status === "Overdue"
                              ? "bg-danger"
                              : "bg-warning text-dark"
                          }`}
                      >
                        {emi.status}
                      </span>
                    </td>
                    {privilegeList.pfgstView && <td>₹{formatCurrency(emi.pfgst)}</td>}
                    <td>₹{formatCurrency(emi.fullEmiAmount)}</td>
                    <td>₹{formatCurrency(emi.fullIntrest)}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="text-center">No EMI data available.</td>
                </tr>
              )}
            </tbody>
          </table>
          <ToastContainer />
        </div>
      </div>
      {showFeesWaveOffPopup && (
  <div className="modal fade show d-block" tabIndex="-1">
    <div className="modal-dialog modal-sm">
      <div className="modal-content">

        <div className="modal-header">
          <h5 className="modal-title">Fees Wave-Off</h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => setShowFeesWaveOffPopup(false)}
          />
        </div>

        <div className="modal-body">
          <div className="mb-2">
            <label>Outstanding Penal Charges</label>
            <input
              className="form-control"
              disabled
              value={`₹${formatCurrency(outstandingFeesAmount)}`}

            />
          </div>

          <div className="mb-2">
            <label>Wave-Off Amount</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter amount"
              value={waveOffAmount}
              onChange={(e) => setWaveOffAmount(e.target.value)}
            />
          </div>
        </div>

        <div className="modal-footer">
          <button
            className="btn btn-secondary btn-sm"
            onClick={() => setShowFeesWaveOffPopup(false)}
          >
            Cancel
          </button>
          <button
            className="btn btn-danger btn-sm"
            onClick={handleFeesWaveOffSubmit}
          >
            Submit
          </button>
        </div>

      </div>
    </div>
  </div>
)}

      {showMandatePopup && (
  <div className="modal fade show d-block" tabIndex="-1">
    <div className="modal-dialog modal-sm">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Mandate Registration</h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => setShowMandatePopup(false)}
          />
        </div>

        <div className="modal-body">
          <div className="mb-2">
            <label>Customer VPA</label>
            <input
              type="text"
              className="form-control"
              placeholder="example@ybl"
              value={customerVpa}
              onChange={(e) => setCustomerVpa(e.target.value)}
            />
          </div>

          <div className="mb-2">
  <label>Mandate Amount</label>

  <input
    type="number"
    step="0.01"
    className="form-control"
    value={mandateAmount}
    onChange={(e) => setMandateAmount(e.target.value)}
    onBlur={() => {
      if (mandateAmount !== "") {
        setMandateAmount(
          formatAmountTwoDecimal(mandateAmount)
        );
      }
    }}
  />

  <small className="text-muted">
    Suggested EMI Amount: ₹{formatAmountTwoDecimal(loan.emiAmount)}
  </small>
</div>

<div className="small text-muted">
  <div>Recurrence: {getRecurrencePattern()}</div>
</div>
        </div>

        <div className="modal-footer">
          <button
            className="btn btn-secondary btn-sm"
            onClick={() => setShowMandatePopup(false)}
          >
            Cancel
          </button>
          <button
            className="btn btn-success btn-sm"
            onClick={handleMandateRegistration}
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  </div>
)}

    </div>
  );
};

export default LoanView;
